
/**
 * FS快照名称长度范围
 */
export enum FsSnapCreateNameLenE {
    Min = 0,
    MultiMax = 251,
    SingleMax = 255,
}

/**
 * FS快照描述长度范围
 */
export enum FsSnapCreateDesLenE {
    Min = 0,
    Max = 1023,
}

/**
 * FS快照Tag长度范围
 */
export enum FsSnapTagLenE {
    Min = 0,
    Max = 32,
}
